import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { SET_ONLINE, SET_PREVENT_ACTION_ON_OFFLINE } from './actionTypes';
/**
 * Contains the action creator functions that update the Connectivity slice of the store.
 *
 * @namespace ConnectivityActions
 */

var actions = function actions() {
  _classCallCheck(this, actions);
};

_defineProperty(actions, "setOnline", function (dispatch, data) {
  var json = {
    type: SET_ONLINE,
    payload: data
  };
  dispatch(json);
});

_defineProperty(actions, "setPreventActionOnOffline", function (dispatch, data) {
  var json = {
    type: SET_PREVENT_ACTION_ON_OFFLINE,
    payload: data
  };
  dispatch(json);
});

export { actions as default };